import posthog from 'posthog-js';

import { BrandingLower } from 'common/env';
const POSTHOG_KEY = process.env.REACT_APP_POSTHOG_KEY;
const POSTHOG_HOST = process.env.REACT_APP_POSTHOG_HOST || 'https://us.i.posthog.com';
const ENVIRONMENT = process.env.REACT_APP_RUNTIME_ENVIRONMENT || 'dev';
const SAMPLING = Number(process.env.REACT_APP_POSTHOG_SAMPLING_RATE || '1');

let initialized = false;

export function initPosthog(appVersion: string) {
    if (!POSTHOG_KEY || initialized) {
        return null;
    }

    // Simple client-side sampling for prod for our limited production trial
    if (ENVIRONMENT === 'prod' && Math.random() >= SAMPLING) {
        return null;
    }

    posthog.init(POSTHOG_KEY, {
        api_host: POSTHOG_HOST,
        capture_pageview: false, // we can do explicit routing if desired
        session_recording: {
            // Mask values in inputs (passwords, card fields, etc.). Non-sensitive inputs can be
            // unmasked per-field with class `ph-ignore-input` (PostHog / rrweb default).
            // Elements with class `ph-no-capture` or attribute `data-recording-sensitive` are
            // blocked from capture entirely.
            maskAllInputs: true,
            blockSelector: '[data-recording-sensitive]',
        },
    });

    posthog.register({
        platform: 'web',
        environment: ENVIRONMENT,
        product_platform: BrandingLower,
        app_version: appVersion,
    });

    initialized = true;
    return posthog;
}

export { posthog };
